import React, {useState, useEffect} from "react";
import {Grid} from "@material-ui/core"
import GeneralSection from "./sections/GeneralSection";
import LocationSection from "./sections/LocationSection";
import SummarySection from "./sections/SummarySection";
import RelatedSection from "../../foundations/firms/form/sections/RelatedSection";
import NewsSection from "./sections/NewsSection";
import InvestmentHistorySection from "./sections/InvestmentHistorySection";
import InvestorService from "../../services/InvestorService";
import ContactsSection from "./sections/ContactsSection";
import HistoricalAumsSection from "./sections/HistoricalAumsSection";
import RealEstateInvestmentHistorySection from "./sections/RealEstateInvestmentHistorySection";

const InvestorInfoSection = (
    {
        investor, setInvestor, investorExtraData, isEditing,
        handleOnChange, handleOnChangeInField, handleShowSnackBar,
        handleOnError, session, setUserMadeChanges, userMadeChanges, dataType, ...props
    }
) => {
    const {
        aums, countries, countriesByRegion, regions,
        states, strategyFocuses, industryWealthOrigins,
        assetClassFocuses, geographicFocuses, extraData,
        investmentStyles, investmentStages, contactResponsibilities,
        investorTypes, relationships, realEstateInvestment
    } = investorExtraData;

    const {
        genders, newsTypes, newsCategories, ...other
    } = extraData.data;

    const [generalErrors, setGeneralErrors] = useState(!isEditing);
    const [locationErrors, setLocationErrors] = useState(false);
    const [contactErrors, setContactErrors] = useState(false);
    const [relatedErrors, setRelatedErrors] = useState(false);
    const [investmentHistoryErrors, setInvestmentHistoryErrors] = useState(false);
    const [realEstateInvestmentErrors, setRealEstateInvestmentErrors] = useState(false);
    const [newsErrors, setNewsErrors] = useState(false);
    const [historicalAumsErrors, setHistoricalAumsErrors] = useState(false);

    const requiredErrors = () => {
        return generalErrors || locationErrors || contactErrors || relatedErrors || investmentHistoryErrors || newsErrors || historicalAumsErrors || realEstateInvestmentErrors
    }

    useEffect(() => {
        handleOnError(0, requiredErrors());
    }, [
        generalErrors, locationErrors, contactErrors, relatedErrors, investmentHistoryErrors, newsErrors, historicalAumsErrors, realEstateInvestmentErrors
    ]);

    const fetchRelationships = () => {
        if (investor.id !== undefined && investor.id !== null) {
            return InvestorService.relationships(investor.id, session);
        }
    }

    const fetchNews = () => {
        if (investor.id !== undefined && investor.id !== null) {
            return InvestorService.news(investor.id, session);
        }
    }

    const fetchInvestments = () => {
        if (investor.id !== undefined && investor.id !== null) {
            return InvestorService.investments(investor.id, session);
        }
    }

    const fetchContacts = () => {
        if (investor.id !== undefined && investor.id !== null) {
            return InvestorService.contacts(investor.id, session, dataType);
        }
    }

    const fetchRealEstateInvestments = () => {
        if (investor.id !== undefined && investor.id !== null) {
            return InvestorService.realEstateInvestment(investor.id, session);
        }
    }

    return (
        <Grid container spacing={2} className="investor-section">
            <GeneralSection
                investor={investor}
                isEditing={isEditing}
                handleOnChange={handleOnChange}
                handleOnChangeInField={handleOnChangeInField}
                handleOnError={setGeneralErrors}
                session={session}
                aums={aums.data}
                strategyFocuses={strategyFocuses.data}
                investorTypes={investorTypes.data}
            />
            <LocationSection
                investor={investor}
                isEditing={isEditing}
                handleOnChange={handleOnChange}
                handleOnChangeInField={handleOnChangeInField}
                handleOnError={setLocationErrors}
                session={session}
                regions={regions.data}
                countries={countries.data}
                countriesByRegion={countriesByRegion.data}
                states={states.data}
            />
            <SummarySection
                investor={investor}
                isEditing={isEditing}
                handleOnChange={handleOnChange}
                handleOnChangeInField={handleOnChangeInField}
                handleOnError={handleOnError}
                handleShowSnackBar={handleShowSnackBar}
                session={session}
                industryWealthOrigins={industryWealthOrigins}
                assetClassFocuses={assetClassFocuses.data}
                geographicFocuses={geographicFocuses.data}
            />
            <RelatedSection
                isEditing={isEditing}
                handleOnChange={handleOnChange}
                handleOnChangeInField={handleOnChangeInField}
                setErrors={setRelatedErrors}
                session={session}
                relationships={relationships.data}
                fetchRelationships={fetchRelationships}
            />
            <ContactsSection
                isEditing={isEditing}
                investorId={investor?.id}
                handleOnChangeInField={handleOnChangeInField}
                handleOnError={setContactErrors}
                session={session}
                genders={genders}
                contactResponsibilities={contactResponsibilities.data}
                fetchContacts={fetchContacts}
                setUserMadeChanges={setUserMadeChanges}
                userMadeChanges={userMadeChanges}
            />
            <InvestmentHistorySection
                isEditing={isEditing}
                handleOnChange={handleOnChange}
                handleOnChangeInField={handleOnChangeInField}
                handleOnError={setInvestmentHistoryErrors}
                session={session}
                investmentStyles={investmentStyles.data}
                investmentStages={investmentStages.data}
                fetchInvestments={fetchInvestments}
            />
            <RealEstateInvestmentHistorySection
              isEditing={isEditing}
              handleOnChange={handleOnChange}
              handleOnChangeInField={handleOnChangeInField}
              handleOnError={setRealEstateInvestmentErrors}
              session={session}
              investmentStyles={investmentStyles.data}
              fetchRealEstateInvestments={fetchRealEstateInvestments}
            />
            <NewsSection
                isEditing={isEditing}
                handleOnChange={handleOnChange}
                handleOnChangeInField={handleOnChangeInField}
                handleOnError={setNewsErrors}
                session={session}
                isDraft={false}
                newsTypes={newsTypes}
                newsCategories={newsCategories}
                fetchNews={fetchNews}
                investor={investor}
            />
        </Grid>
    )
}

export default InvestorInfoSection;